import "./DateField.css";

/** Keep YYYY-MM-DD without timezone conversion. */
export function toDateInputValue(raw) {
  if (!raw) return "";
  const text = String(raw).trim();
  const match = text.match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : "";
}

export default function DateField({
  value,
  onChange,
  disabled,
  label = "날짜",
  name,
  testId,
}) {
  const display = toDateInputValue(value);

  const setValue = (next) => {
    const cleaned = String(next || "").replace(/[^\d-]/g, "").slice(0, 10);
    onChange(toDateInputValue(cleaned) || cleaned);
  };

  return (
    <label className="ds-date">
      {label ? <span className="ds-date__label">{label}</span> : null}
      <span className="ds-date__row">
        <input
          type="text"
          name={name}
          inputMode="numeric"
          autoComplete="off"
          placeholder="YYYY-MM-DD"
          value={display}
          disabled={disabled}
          data-testid={testId}
          onChange={(e) => setValue(e.target.value)}
          onBlur={() => onChange(toDateInputValue(display))}
        />
        <input
          type="date"
          className="ds-date__picker"
          value={display}
          disabled={disabled}
          aria-label={`${label || "날짜"} 선택`}
          onChange={(e) => onChange(e.target.value || "")}
        />
      </span>
    </label>
  );
}
